import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { LocalStorageService } from "../storage/local-storage.service";
import { OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc-jwks";
import { AppConfig } from "../../../app.config";
import { MatDialog } from "@angular/material/dialog";
import { AppControllerService } from "../../../app-controller.service";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let AuthService = class AuthService {
    http;
    localStorage;
    matDialog;
    oauthService;
    appController;
    $isNotAuthenticated;
    authenticationTokenSubject = new BehaviorSubject("");
    $authenticationToken = this.authenticationTokenSubject.asObservable();
    isAuthenticatedSubject = new BehaviorSubject(false);
    $isAuthenticated = this.isAuthenticatedSubject.asObservable();
    eventsSubscription;
    constructor(http, localStorage, matDialog, oauthService, appController) {
        this.http = http;
        this.localStorage = localStorage;
        this.matDialog = matDialog;
        this.oauthService = oauthService;
        this.appController = appController;
        this.setupListeners();
        this.listenForSecurityTokenServiceEvents();
    }
    getAuthToken() {
        return this.authenticationTokenSubject.value;
    }
    authenticate() {
        const authConfig = AppConfig.settings.ids;
        authConfig.useSilentRefresh = true;
        this.oauthService.configure(authConfig);
        this.oauthService.loadDiscoveryDocument();
        return this.redirectAuthenticate();
    }
    redirectAuthenticate() {
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.setupAutomaticSilentRefresh();
        const call = this.oauthService.loadDiscoveryDocumentAndLogin();
        call.then(() => {
            this.handleLoginAttempt();
        });
        return call;
    }
    logOutRedirect() {
        const url = `${AppConfig.settings.ids.issuer}/Account/LogoutClient?returnUrl=${AppConfig.settings.ids.redirectUri}`;
        window.open(url, "_self");
    }
    unAuthenticate() {
        this.oauthService.revokeTokenAndLogout(false, true);
        this.publishTokenValidityChange(false);
    }
    checkIfLoggedIn() {
        if (this.oauthService.hasValidAccessToken()) {
            this.handleTokenValid();
            // this.localStorage.remove(LocalStorageEnum.Url)
            return true;
        }
        return false;
    }
    localLogout() {
        this.oauthService.logOut(true);
        this.publishTokenValidityChange(false);
    }
    setupListeners() {
        this.$isNotAuthenticated = this.$isAuthenticated.pipe(map((isAuthenticated) => !isAuthenticated));
    }
    handleLoginAttempt() {
        const isTokenValid = this.oauthService.hasValidIdToken();
        if (isTokenValid) {
            this.handleTokenValid();
        }
    }
    publishTokenValidityChange(value) {
        this.isAuthenticatedSubject.next(value);
    }
    publishToken(accessToken) {
        this.authenticationTokenSubject.next(accessToken);
    }
    handleTokenValid() {
        this.publishToken(this.oauthService.getAccessToken());
        this.publishTokenValidityChange(true);
    }
    listenForSecurityTokenServiceEvents() {
        this.eventsSubscription = this.oauthService.events.subscribe((event) => {
        });
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: LocalStorageService },
        { type: MatDialog },
        { type: OAuthService },
        { type: AppControllerService }
    ];
};
AuthService = __decorate([
    Injectable(),
    AutoUnsub()
], AuthService);
export { AuthService };
